module.exports = __webpack_public_path__ + "9230e95cc98031a786ee6d54cc932807.png";